import React from 'react';

export default function BookingHeader(props) {

    return (
		<div className="booking-header">
			<img src={props.img} alt={props.commercialName} />
		</div>
	);
}